// NOTE: Also see useAsyncStoryblokStories

export function useStoryblokStories(...parameters: Parameters<typeof useStoryblokStoriesData>) {
    const { data } = useStoryblokStoriesData(...parameters);

    return computed(() => data.value?.stories || []);
}
